import { render, staticRenderFns } from "./AddFromGalleryTemplateModal.vue?vue&type=template&id=33f8673d&scoped=true"
import script from "./AddFromGalleryTemplateModal.vue?vue&type=script&lang=js"
export * from "./AddFromGalleryTemplateModal.vue?vue&type=script&lang=js"
import style0 from "./AddFromGalleryTemplateModal.vue?vue&type=style&index=0&id=33f8673d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f8673d",
  null
  
)

export default component.exports